package de.n4.careflex.login.exceptions

class NotAuthenticatedException(message: String? = null, cause: Throwable? = null): Exception(message, cause)